define('SageDotCom/DataLayer/Events/searchRefinement',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function SearchRefinementEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'search_int_refine'; // overwrite name
    }

    SearchRefinementEvent.prototype = Object.create(EventBase.prototype);

    SearchRefinementEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, term, facets, url) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': '0',
            'event_category': 'search',
            'event_action': 'search',
            'event_label': 'search refinement',
            'event_name_level_1': this.getId(scope),
            'event_name_level_2': url,
            'event_name_level_3': term,
            'event_name_level_4': facets
        }

        return eventData;
    }

    return new SearchRefinementEvent();
});
